import { customTransactionsSapInventory } from "integration/generated/customTransactions";
import { RequestParams } from "integration/generated/customTransactions/http-client";
import { GetServerSidePropsContext } from "next";
import { error as logError } from '@/data/utils/loggerUtil';
import useSWR from "swr";
import { EMPTY_STRING } from "@/data/constants/marketing";
import { useSettings } from "@/data/Settings";

const DATA_KEY = 'SAP_STORE_STOCK';

export const sapInventoryCheckFetcher =
	(pub: boolean, context?: GetServerSidePropsContext) =>
		async (
			storeId: string,
			orderId:string,
			query: {
				source: string;
				physicalStoreId: string;
			}
		) => {
			return await customTransactionsSapInventory(pub).sapInventoryAvailabilityCheckInventoryByOrderIdDetail(
				storeId,
				orderId,
				query,
				{}
			);
		};

const fetcher =
	(pub: boolean, context?: GetServerSidePropsContext) =>
	async (
		storeId: string,
		query: {
			storeNumber: string;
			partNumber: string;
			[key:string]:string | boolean | undefined | string[]
		},
		params: RequestParams
	) => {
		try {
			const data = await customTransactionsSapInventory(pub).sapInventoryAvailabilityGetStoreInventoryByStoreNumbersAndPartNumberDetail(
				storeId,
				query,
				params
			);
			return data;
		} catch (error) {
			logError(context?.req, 'StoreLocator: fetcher: error: %o', error);
		}
	};

export const useSapStoreStock = (storeNumber: string, partNumber: string, hasLimit?:boolean) => {
	const {settings} = useSettings();
	const { data, isLoading } = useSWR(
		storeNumber && storeNumber!==EMPTY_STRING && partNumber?.length>0
				? [
						{
							storeId: settings?.storeId,
							query: {
								storeNumber,
								partNumber,
								hasLimit,
								isOrder:true
							},
						},
						DATA_KEY,
				  ]
				: null,
			async ([props]) =>
				fetcher(true)(props.storeId, props.query, {}),{refreshInterval:1}
		);
		return {
			sapStoreStock:data, isLoading
		}
	}

